import * as ActionTypes from '../constants/ActionTypes';
import * as EventTags from './tags';

export default {
  [ActionTypes.USER_LOGOUT]: EventTags.USER_LOGOUT,
};
